import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { MuiGradientButtonOverride } from 'theme/overrides';
var GradientButton = withStyles(MuiGradientButtonOverride)(Button);
export default GradientButton;